import { errResult } from 'libs/end-to-end/src/result';
import { okResult } from 'libs/end-to-end/src/result';
import { Result } from 'libs/end-to-end/src/result';
import { CsvUnparseError } from 'libs/end-to-end/src/types/errors/csv-unparse-error';
import { unparse } from 'papaparse';

/**
 * This method can convert simple arrays of objects to CSV strings.
 * @param rows
 */
export const csvUnparse = <TRecord>(
  rows: TRecord[],
): Result<string, CsvUnparseError> => {
  try {
    return okResult(unparse(rows));
  } catch (e) {
    return errResult({
      errorType: 'CsvUnparseError',
      errorReason: e instanceof Error ? e.message : 'Unknown error',
    });
  }
};
